/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPieSeveralParts: {
  name: 'pie-several-parts';
  data: string;
} = {
  name: 'pie-several-parts',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 4.062v5.803l4.36-3.633a1 1 0 0 1 .103-.076A7.973 7.973 0 0 0 13 4.062Zm5.734 3.617a1 1 0 0 1-.094.09l-4.825 4.02 5.734 2.867A7.989 7.989 0 0 0 20 12a7.963 7.963 0 0 0-1.266-4.32Zm-.081 8.766L12 13.118l-6.653 3.327A7.992 7.992 0 0 0 12 20a7.992 7.992 0 0 0 6.653-3.555ZM4.452 14.656 11 11.382v-7.32a8.001 8.001 0 0 0-6.548 10.594ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z" fill="currentColor"/></svg>`,
};
